import styled from 'styled-components';
import { PageSectionHeading , 
  GhostButtonComponent as GhostButtonComponentCommon,
  PrimaryButtonComponent as PrimaryButtonComponentCommon,
  UnderlineLink,
  DisplayFlex
} from "../../../../../../CommonComponents/commonStyles";
import { PoolTable, ButtonLoader } from '../../styles';

export const ProcessingContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.point5};
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    margin-left: 0.5rem;
  }
  justify-content: space-between;
  & > div:nth-child(1) {
    flex-direction: column;
    
  }
  & > div:last-child {
    align-self: center;
    span {
      letter-spacing: ${props => props.theme.letterSpacing.point6};
    };
  }
  .confirmation-fields {
    ${DisplayFlex}{
      margin-bottom: 15px;
      @media only screen and (max-width: 767px) {
        margin-bottom: 5px;
      }
    }
  }
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    & > div:nth-child(1) {
      & > div:last-child {        
        & div:nth-child(1) {
          margin-bottom: 1.25rem;
          &:after {
            display: none;
          }
        }
      }
    }
    & > div:last-child {
      align-self: start;
      margin-top: 2rem;
    }
  }
`;

export const PageHeading = styled(PageSectionHeading)`
    padding-right: 12px;
`

export const FlexContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 20px;
`;

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row:nth-child(2n + 1) {
    background-color: ${props =>
    props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-input-number {
    width: 100% !important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-table-footer {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-bottom: solid 1px #9b9b9b;
    height: 80px;
    @media only screen and (max-width: 767px) {
      height: auto;
    }
  }
  .hide-col-title-in-mobile button span {
    font-family:${props =>props.theme.fontFamily.helveticaNeueMedium};
    font-size:${props =>props.theme.fontSize.secondary};
    @media only screen and (max-width: 768px) {
    letter-spacing: ${props =>props.theme.letterSpacing.zero};
    }
  }
  .hide-col-title-in-mobile a {
    @media only screen and (max-width: 768px) {
    font-size:${props =>props.theme.fontSize.secondary};
    }
  }
`;

export const GhostButtonComponent = styled(GhostButtonComponentCommon)`
  width: auto;
`; 

export const PrimaryButtonComponent = styled(PrimaryButtonComponentCommon)`
  width: auto;
`;

export const ButtonWrapper = styled.div`
  @media only screen and (max-width: 991px) {    
    width: 100%;
    flex-wrap: wrap;
    button{
      margin: 0 0 16px 0 !important;
      &:last-child{
        margin: 0 !important;
      }
    }
  }
`;

export const UnderlineLinkComponent = styled(UnderlineLink)`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  &[disabled] {
    color: rgba(0, 0, 0, 0.25) !important;
  }
  position: relative;
  ${({ loading }) => loading && `
    color: transparent !important;
    cursor: not-allowed;
    ${ButtonLoader}{
      display: block;
    }
  `}
`